function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e06852;fill-rule:evenodd;}.cls-2{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M51.74,44.34c38.1-31.8,78.9-67.5,124.8-24.2h-4.6c-53-36.7-114.6,29.1-127.6,30.2l.8-1.8,11.3-26h4.5l3.9,9-3.6,2.8-2.6-6.1C57.74,30.44,51.14,43.64,51.74,44.34ZM67.54,38l-4,2.2,4.4,10.1h5Z",
  transform: "translate(-2.33 -0.1)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M12,50.63c-5.6,0-9.56-3.12-9.64-7.72H6.21c.24,2.32,1.88,4.64,5.76,4.64,3.53,0,5.61-2,5.61-4.64,0-7.53-15.09-2.72-15.09-13.09,0-4.6,3.72-7.72,9.24-7.72,5.33,0,8.81,2.92,9.25,7.16H17c-.24-1.88-2-4-5.41-4-3-.08-5.36,1.48-5.36,4.48,0,7.2,15.05,2.72,15.05,13.05C21.26,46.71,18,50.63,12,50.63Z",
  transform: "translate(-2.33 -0.1)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M36.61,38.71H31.25V50.35H27.61V22.46h9c6.57,0,9.65,3.6,9.65,8.16C46.26,34.86,43.54,38.71,36.61,38.71Zm0-3c4.17,0,5.93-2,5.93-5.08s-1.76-5.16-5.93-5.16H31.25V35.7Z",
  transform: "translate(-2.33 -0.1)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M97.55,31.35c3.72,0,6.15,2,6.72,5.07H103c-.48-2.5-2.59-4-5.45-4-3.13,0-5.85,2.07-5.85,6.47s2.72,6.5,5.85,6.5c2.86,0,5-1.51,5.45-4h1.27c-.57,3-3,5.1-6.72,5.1-4.13,0-7.09-2.86-7.09-7.56S93.42,31.35,97.55,31.35Z",
  transform: "translate(-2.33 -0.1)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M108,26.23h1.22v20H108Z",
  transform: "translate(-2.33 -0.1)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M120.07,46.41c-4.1,0-7.2-2.86-7.2-7.56s3.16-7.5,7.26-7.5,7.2,2.83,7.2,7.5S124.18,46.41,120.07,46.41Zm0-1.08c3.08,0,6.05-2,6.05-6.48s-2.94-6.45-6-6.45-6,2-6,6.45S117,45.33,120.07,45.33Z",
  transform: "translate(-2.33 -0.1)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M143.41,46.19h-1.22V43a5.38,5.38,0,0,1-5.36,3.42c-3.27,0-5.94-1.94-5.94-6.36V31.54h1.19V40c0,3.59,2,5.4,4.91,5.4s5.2-1.92,5.2-6V31.54h1.22Z",
  transform: "translate(-2.33 -0.1)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M154.14,31.35a6.41,6.41,0,0,1,6.21,4V26.23h1.21v20h-1.21V42.3a6.28,6.28,0,0,1-6.21,4.11c-4.1,0-7.06-2.95-7.06-7.56S150,31.35,154.14,31.35Zm.16,1c-3.53,0-6,2.4-6,6.45s2.45,6.48,6,6.48,6-2.51,6-6.48S157.73,32.4,154.3,32.4Z",
  transform: "translate(-2.33 -0.1)"
});

var SvgSpaCloud = function SvgSpaCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 174.21 50.53",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpaCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spa-cloud.857054ea.svg";
export { ForwardRef as ReactComponent };